'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var generateLoader = exports.generateLoader = function generateLoader(container, clazz, attributes, size) {
  var x = '';

  size = size || 48;

  if (container) x += '<div class="o-loader__container ' + (clazz ? clazz : '') + '" ' + (attributes ? attributes : '') + '>';

  x += '\n    <span class="o-loader">\n      <svg width="' + size + '" height="' + size + '" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg">\n        <g fill="none" fill-rule="evenodd">\n          <g transform="translate(1 1)" stroke-width="3">\n            <circle stroke-opacity=".5" cx="18" cy="18" r="18"/>\n            <path id="loader-path" d="M36 18c0-9.94-8.06-18-18-18"></path>\n          </g>\n        </g>\n      </svg>\n    </span>\n  ';

  if (container) x += '</div>';
  return x;
};